import { useFragment } from "react-relay"
import { getEpisodeOfCareFragment } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-fragment"
import { EpisodeOfCareFragment$key } from "@/modules/patients/detail/episode-of-care/types/episode-of-care-fragment-type"
import { useEpisodeOfCareStoreContext } from "@/modules/patients/detail/store/useEpisodeOfCareStore"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { Country } from "@/types/__generated__/union-types"

const useLatestDiagnosisCode = (progressNoteId?: string) => {
  const countryCode: Country = useCountryParam()
  const progressNoteAndParentData = useEpisodeOfCareStoreContext((state) => state.progressNoteAndParentData)
  const progressNoteObj = progressNoteAndParentData.find(
    (progressNode) => progressNode.episodeOfCareProgressNoteData.id === progressNoteId,
  )

  if (!progressNoteObj) {
    throw new Error("Progress note not found")
  }

  const episodeOfCareData = useFragment<EpisodeOfCareFragment$key>(
    getEpisodeOfCareFragment(countryCode),
    progressNoteObj.parentEpisodeOfCare,
  )

  const icdCode = episodeOfCareData?.icdDiagnosis.diagnosisCode

  const diagnosisCode = (progressNoteObj?.episodeOfCareProgressNoteData.episodeOfCareId && icdCode) ?? ""

  return { diagnosisCode }
}

export { useLatestDiagnosisCode }
